import { AxiosResponse } from 'axios';

import apiClient from '../client';
import { PageResultDto } from 'interfaces/page';
import { CreateOrderDto, OrderDto } from 'interfaces/orders/order';
import { ApiResponseDto } from 'interfaces/apiResponse';

interface OrderService {
  search(queryParams?: any): Promise<PageResultDto<OrderDto>>;
  get(id: string): Promise<OrderDto>;
  create(postData: CreateOrderDto): Promise<OrderDto>;
  clone(id: string): Promise<OrderDto>;
  update(id: string, postData: CreateOrderDto): Promise<OrderDto>;
  delete(id: string): void;
}

const endpoints = {
  searchOrders: '/orders',
  getOrder: (id: string) => `/orders/${id}`,
  createOrder: '/orders',
  cloneOrder: (id: string) => `/orders/${id}/clone`,
  editOrder: (id: string) => `/orders/${id}`,
  deleteOrder: (id: string) => `/orders/${id}`,
};

export const ordersService: OrderService = {
  search: async (queryParams?: any): Promise<PageResultDto<OrderDto>> => {
    const response: AxiosResponse<ApiResponseDto<PageResultDto<OrderDto>>> = await apiClient.get(endpoints.searchOrders, {
      params: { ...queryParams },
      paramsSerializer: { indexes: null },
    });

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  get: async (id: string): Promise<OrderDto> => {
    const response: AxiosResponse<ApiResponseDto<OrderDto>> = await apiClient.get(endpoints.getOrder(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  create: async (postData: CreateOrderDto): Promise<OrderDto> => {
    const response: AxiosResponse<ApiResponseDto<OrderDto>> = await apiClient.post(endpoints.createOrder, postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  clone: async (id: string): Promise<OrderDto> => {
    const response: AxiosResponse<ApiResponseDto<OrderDto>> = await apiClient.post(endpoints.cloneOrder(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  update: async (id: string, postData: CreateOrderDto): Promise<OrderDto> => {
    const response: AxiosResponse<ApiResponseDto<OrderDto>> = await apiClient.put(endpoints.editOrder(id), postData);

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
  delete: async (id: string): Promise<void> => {
    const response: AxiosResponse<ApiResponseDto<OrderDto>> = await apiClient.delete(endpoints.deleteOrder(id));

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }
  },
};
